module.exports = __webpack_public_path__ + "img/li3.4aa076f5.png";